<template>
  <div>
    <div class="cardCustom">
      <div class="card cardCustom__side">
        <div class="cardCustom__header">
          <header>{{ header }}</header>
        </div>

        <div v-if="tabs.length > 0" class="content mt-10">
          <div v-if="loading" :class="{ bgBlur: true }" :style="{ height: '100%' }"></div>

          <nav class="mb-5">
            <div v-for="(tab, index) in tabs" v-bind:key="index">
              <p-button v-if="isActive(tab)" type="success" class="mr-2"> {{ tab.name }} </p-button>
              <p-button
                v-else
                type="success"
                class="mr-2"
                outline
                @click.prevent.native="changeSelectedTab(index, tab)"
              >
                {{ tab.name }}
              </p-button>
            </div>
          </nav>

          <div v-for="(tab, index) in tabs" v-bind:key="index">
            <div class="content" v-if="isActive(tab)">
              <div class="title flex">
                <div class="mr-4">{{ tab.title }}</div>
                <FavoriteButton
                  v-if="tab.question"
                  class="pl-2"
                  :answer="tab.answer"
                  :question="tab.question"
                  :company="company"
                ></FavoriteButton>
              </div>
              <p class="tab__body-text">{{ tab.body }}</p>
            </div>
          </div>

          <div v-if="loading" class="loadingSection lds-dual-ring"></div>
        </div>
        <div v-else class="content mt-10">
          <h5>Unfortunately, there are no tips for this category yet.</h5>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FavoriteButton from '@/components/buttons/FavoriteButton';
export default {
  name: 'Tab',
  components: { FavoriteButton },
  props: {
    header: {
      type: String,
    },
    tabs: {
      type: Array,
    },
    company: Object,
    loading: Boolean,
  },
  data() {
    return {
      selectedTab: this.tabs[0],
    };
  },
  computed: {
    getStyle() {
      let vm = this;
      console.log(vm);
      let index = this.tabs.findIndex(function (tab) {
        return tab.id === vm.selectedTab.id;
      });
      console.log(index);
      return { left: index * 16.7 + '%' };
    },
  },
  methods: {
    changeSelectedTab(index, tab) {
      this.selectedTab = tab;
    },
    isActive(tab) {
      return this.selectedTab.id === tab.id;
    },
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@200;300;400;500;600;700&display=swap');
body {
  overflow: hidden;
  padding: 0 20px;
  background: #17a2b8;
}

.wrapper header {
  font-size: 30px;
  font-weight: 600;
  padding-bottom: 20px;
}
.wrapper nav {
  position: relative;
  width: auto;
  height: 50px;
  display: flex;
  align-items: center;
}

.title {
  font-size: 21px;
  font-weight: 500;
  margin: 30px 0 10px 0;
}
p {
  text-align: justify;
}
</style>
